module.exports = __webpack_public_path__ + "static/frost_salamander-d8d7937d85519cecbba82dfe25d29b64.png";